;(function(){
  // update the <p id="inventory-status"> based on a variant ID
  function updateInventoryMessage(variantId) {
    var variants    = window.productVariants    || [];
    var restockDate = (window.productRestockDate || '').trim();
    var v           = variants.find(function(v){ return v.id == variantId });
    var el          = document.getElementById('inventory-status');
    if (!v || !el) return;

    // reset classes/text
    el.className = 'inventory-status';
    el.textContent = '';

    if (v.available) {
      if (v.inventory_quantity > 10) {
        el.textContent = 'In Stock, Ready to Ship';
        el.classList.add('in-stock');
      } else {
        el.textContent = 'Hurry, Only ' + v.inventory_quantity + ' Units Left in Stock!';
        el.classList.add('low-stock');
      }
    } else {
      el.textContent = restockDate 
        ? 'Out of Stock, ' + restockDate 
        : 'Out of Stock';
      el.classList.add('out-of-stock');
    }
  }

  document.addEventListener('page:loaded', function(){
    // 1) INITIAL: grab whatever variant is already selected on page load
    var selector = document.querySelector(
      'form[action="/cart/add"] select[name="id"],' +
      'form[action="/cart/add"] input[name="id"]'
    );
    if (selector && selector.value) {
      updateInventoryMessage(selector.value);
    } else if (window.productVariants && productVariants.length) {
      // fallback to first variant
      updateInventoryMessage(window.productVariants[0].id);
    }

    // 2) ON VARIANT CHANGES: same as before
    document.addEventListener('variant:change', function(evt){
      if (evt.detail && evt.detail.variant && evt.detail.variant.id) {
        updateInventoryMessage(evt.detail.variant.id);
      }
    });
  });
})();

